import { Injectable, inject } from '@angular/core';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Event } from '../../models';
import { EventsService } from '../../services';

// todo migrate to resolve function
// How to handle the currentEvent ? => user service ?
@Injectable({
  providedIn: 'root',
})
export class IncommingEventsResolver  {
  private eventsService = inject(EventsService);

  events: {count: number, rows: Event[]};

  resolve() {
    if (this.events) {
      return of(this.events);
    }
    return this.eventsService.getIncommingEvents(24)
      .pipe(
        tap((res) => {
          this.events = res;
          this.events.rows = this.events.rows.map((event) => new Event(event));
          return this.events;
        }),
        catchError((err) => {
          // eslint-disable-next-line no-console
          console.error('unable to retrieve incomming events');
          return of([]);
        }),
      );
  }

}
